import './App.css';
import Header from './sections/header/header.component';
import Content from './sections/content/content.component';
import Footer from './sections/footer/footer.component';

function App() {
  return (
    <div className="App">
      <Header />
      <Content />
      <Footer />
    </div>
  );
}

export default App;
